export const errorList = [
  {
    code: 1,
    fr: "Une erreur est survenue",
    default: "Une erreur est survenue",
  },
  {
    code: 2,
    fr: "Une erreur est survenue",
    default: "Une erreur est survenue",
  },
  {
    code: 3,
    fr: "Une erreur est survenue",
    default: "Une erreur est survenue",
  },
  {
    code: 4,
    fr: "Une erreur est survenue",
    default: "Une erreur est survenue",
  },
  {
    code: 5,
    fr: "Cette action n’est pas autorisée",
    default: "Cette action n’est pas autorisée",
  },
  {
    code: 6,
    fr: "Une erreur est survenue",
    default: "Une erreur est survenue",
  },
  {
    code: 12,
    fr: "Une erreur est survenue",
    default: "Une erreur est survenue",
  },
  {
    code: 13,
    fr: "Une erreur est survenue",
    default: "Une erreur est survenue",
  },
  {
    code: 14,
    fr: "Une erreur est survenue",
    default: "Une erreur est survenue",
  },
  {
    code: 7,
    fr: "Une erreur est survenue lors du chargement des données",
    default: "Une erreur est survenue lors du chargement des données",
  },
  {
    code: 8,
    fr: "Une erreur est survenue lors du chargement des données",
    default: "Une erreur est survenue lors du chargement des données",
  },
  {
    code: 9,
    fr: "Une erreur est survenue lors de la récupération des ressources",
    default: "Une erreur est survenue lors de la récupération des ressources",
  },
  {
    code: 10,
    fr: "Une erreur est survenue lors de la récupération des ressources",
    default: "Une erreur est survenue lors de la récupération des ressources",
  },
  {
    code: 11,
    fr: "Une erreur est survenue lors de la récupération des ressources",
    default: "Une erreur est survenue lors de la récupération des ressources",
  },
  {
    code: 18,
    fr: "Une erreur est survenue",
    default: "Une erreur est survenue",
  },
  {
    code: 19,
    fr: "Une erreur est survenue lors du téléchargement du fichier",
    default: "Une erreur est survenue lors du téléchargement du fichier",
  },
  {
    code: 20,
    fr: "La connexion avec le partenaire de paiement a été interrompue",
    default: "La connexion avec le partenaire de paiement a été interrompue",
  },
  {
    code: 21,
    fr: "La date de saisie du repas est dans le passé",
    default: "La date de saisie du repas est dans le passé",
  },
  {
    code: 15,
    fr: "Un repas a déjà été saisi pour la même heure",
    default: "Un repas a déjà été saisi pour la même heure",
  },
  {
    code: 16,
    fr: "La date de fin est antérieure à la date de début",
    default: "La date de fin est antérieure à la date de début",
  },
  {
    code: 17,
    fr: "La période renseignée ne peut pas être supérieure à deux mois",
    default: "La période renseignée ne peut pas être supérieure à deux mois",
  },
  {
    code: 1001,
    fr:
      "Vous devez activer votre compte en suivant le lien qui vous a été envoyé par email",
    default:
      "Vous devez activer votre compte en suivant le lien qui vous a été envoyé par email",
  },
  {
    code: 1002,
    fr: "Aucun compte ne correspond aux identifiants fournis",
    default: "Aucun compte ne correspond aux identifiants fournis",
  },
  {
    code: 1003,
    fr: "Les deux champs mot de passe doivent être identiques",
    default: "Les deux champs mot de passe doivent être identiques",
  },
  {
    code: 1004,
    fr:
      "Le format du mot de passe n’est pas valide (Au moins 8 caractères dont au moins un chiffre et une lettre majuscule)",
    default:
      "Le format du mot de passe n’est pas valide (Au moins 8 caractères dont au moins un chiffre et une lettre majuscule)",
  },
  {
    code: 1005,
    fr:
      "Aucune demande de réinitialisation n’a été  enregistrée pour ce compte",
    default:
      "Aucune demande de réinitialisation n’a été  enregistrée pour ce compte",
  },
  {
    code: 1006,
    fr: "La demande de réinitialisation a expiré, merci de la renouveler",
    default: "La demande de réinitialisation a expiré, merci de la renouveler",
  },
  {
    code: 1007,
    fr: "Aucun abonnement actif n’est associé à ce compte",
    default: "Aucun abonnement actif n’est associé à ce compte",
  },
  {
    code: 2001,
    fr: "Le nom de la crèche est déjà utilisé par un autre utilisateur",
    default: "Le nom de la crèche est déjà utilisé par un autre utilisateur",
  },
  {
    code: 2002,
    fr: "Adresse email invalide",
    default: "Adresse email invalide",
  },
  {
    code: 2018,
    fr: "Numéro de téléphone invalide",
    default: "Numéro de téléphone invalide",
  },
  {
    code: 2003,
    fr: "Une erreur est survenu chez le partenaire pas paiement",
    default: "Une erreur est survenu chez le partenaire pas paiement",
  },
  {
    code: 2004,
    fr: "L’adresse email est déjà utilisée par un autre utilisateur",
    default: "L’adresse email est déjà utilisée par un autre utilisateur",
  },
  {
    code: 2011,
    fr:
      "Vous ne pouvez pas combiner des photos et des vidéos dans la même publication",
    default:
      "ous ne pouvez pas combiner des photos et des vidéos dans la même publication",
  },
  {
    code: 2012,
    fr: "Une erreur est survenue lors de l’envoi de votre publication",
    default: "Une erreur est survenue lors de l’envoi de votre publication",
  },
  {
    code: 2013,
    fr:
      "Vous ne pouvez pas combiner des photos et des vidéos dans la même publication",
    default:
      "Vous ne pouvez pas combiner des photos et des vidéos dans la même publication",
  },
  {
    code: 2014,
    fr: "Une erreur est survenue lors de l’envoi de votre publication",
    default: "Une erreur est survenue lors de l’envoi de votre publication",
  },
  {
    code: 2015,
    fr: "Vous ne pouvez pas envoyer plus de 30 photos dans la même publication",
    default:
      "Vous ne pouvez pas envoyer plus de 30 photos dans la même publication",
  },
  {
    code: 2016,
    fr: "Une erreur est survenue lors de l’envoi de votre publication",
    default: "Une erreur est survenue lors de l’envoi de votre publication",
  },
  {
    code: 2017,
    fr: "Une erreur est survenue lors de l’envoi de votre publication",
    default: "Une erreur est survenue lors de l’envoi de votre publication",
  },
  {
    code: 2019,
    fr: "Une erreur est survenue lors de l’envoi de votre publication",
    default: "Une erreur est survenue lors de l’envoi de votre publication",
  },
  {
    code: 4018,
    fr: "La date de fin est antérieure à la date de début",
    default: "La date de fin est antérieure à la date de début",
  },
  {
    code: 2006,
    fr: "Un planning des ressources existe déjà pour la date sélectionnée",
    default: "Un planning des ressources existe déjà pour la date sélectionnée",
  },
  {
    code: 2007,
    fr: "Vous ne pouvez pas planifier les ressources pour une semaine passée",
    default:
      "Vous ne pouvez pas planifier les ressources pour une semaine passée",
  },
  {
    code: 2010,
    fr: "Vous ne pouvez pas copier le planning vers une semaine passée",
    default: "Vous ne pouvez pas copier le planning vers une semaine passée",
  },
  {
    code: 2008,
    fr: "Une erreur est survenue lors de la planification des ressources",
    default: "Une erreur est survenue lors de la planification des ressources",
  },
  {
    code: 2009,
    fr: "Une erreur est survenue lors de la planification des ressources",
    default: "Une erreur est survenue lors de la planification des ressources",
  },
  {
    code: 3003,
    fr: "Adresse email invalide",
    default: "Adresse email invalide",
  },
  {
    code: 3004,
    fr: "Cet identifiant est déjà utilisé par un autre utilisateur",
    default: "Cet identifiant est déjà utilisé par un autre utilisateur",
  },
  {
    code: 3005,
    fr:
      "Le format du mot de passe est invalide (Au moins 8 caractères dont au moins un chiffre et une lettre majuscule)",
    default:
      "Le format du mot de passe est invalide (Au moins 8 caractères dont au moins un chiffre et une lettre majuscule)",
  },
  {
    code: 3006,
    fr: "Les deux champs mot de passe doivent être identiques",
    default: "Les deux champs mot de passe doivent être identiques",
  },
  {
    code: 3007,
    fr: "Le numéro de téléphone est invalide",
    default: "Le numéro de téléphone ets invalide",
  },
  {
    code: 3008,
    fr: "Le type de compte sélectionné n’est pas reconnu",
    default: "Le type de compte sélectionné n’est pas reconnu",
  },
  {
    code: 3009,
    fr: "Vous ne pouvez pas planifier un événement à une date passée",
    default: "Vous ne pouvez pas planifier un événement à une date passée",
  },
  {
    code: 3010,
    fr:
      "Une erreur est survenue lors de la modification du type de l’événement",
    default:
      "Une erreur est survenue lors de la modification du type de l’événement",
  },
  {
    code: 3011,
    fr: "Une erreur est survenue lors de la modification de l’événement",
    default:
      "Une erreur est survenue lors de la modification du type de l’événement",
  },
  {
    code: 3012,
    fr: "Vous devez saisir au moins un menu",
    default: "Vous devez saisir au moins un menu",
  },
  {
    code: 3013,
    fr: "Une erreur est survenue lors de la suppression des notifications",
    default: "Une erreur est survenue lors de la suppression des notifications",
  },
  {
    code: 4001,
    fr: "Cet enfant est déjà enregistré",
    default: "Cet enfant est déjà enregistré",
  },
  {
    code: 4002,
    fr: "L’adresse email est invalide",
    default: "L’adresse email est invalide",
  },
  {
    code: 4003,
    fr: "Le numéro de téléphone d’un des parents est invalide",
    default: "Le numéro de téléphone d’un des parents est invalide",
  },
  {
    code: 4004,
    fr: "Le numéro de téléphone d’un des tiers autorisés est invalide",
    default: "Le numéro de téléphone d’un des tiers autorisés est invalide",
  },
  {
    code: 40028,
    fr: "Les parents doivent avoir des adresses email différentes",
    default: "Les parents doivent avoir des adresses email différentes",
  },
  {
    code: 4005,
    fr: "Une erreur est survenue lors de la mise à jour du statut de l’enfant",
    default:
      "Une erreur est survenue lors de la mise à jour du statut de l’enfant",
  },
  {
    code: 4006,
    fr: "La modification du statut de l’enfant n’est pas autorisée",
    default: "La modification du statut de l’enfant n’est pas autorisée",
  },
  {
    code: 4007,
    fr: "L’heure de fin de la sieste est antérieure à l’heure de début",
    default: "L’heure de fin de la sieste est antérieure à l’heure de début",
  },
  {
    code: 4008,
    fr:
      "La saisie de la sieste ne peut être acceptée que pour la journée courante",
    default:
      "La saisie de la sieste ne peut être acceptée que pour la journée courante",
  },
  {
    code: 4009,
    fr: "Vous devez saisir un message pour cet incident",
    default: "Vous devez saisir un message pour cet incident",
  },
  {
    code: 4010,
    fr:
      "La saisie d’un incident ne peut être acceptée que pour la journée courante",
    default:
      "La saisie d’un incident ne peut être acceptée que pour la journée courante",
  },
  {
    code: 4011,
    fr: "Vous devez saisir le texte du message",
    default: "Vous devez saisir le texte du message",
  },
  {
    code: 4012,
    fr:
      "Vous devez renseigner la personne qui va récupérer l’enfant à sa sortie",
    default:
      "Vous devez renseigner la personne qui va récupérer l’enfant à sa sortie",
  },
  {
    code: 4033,
    fr:
      "Des événements ont été enregistrés pour cet enfant, la suppression de l’arrivée n’est pas autorisée",
    default:
      "Des événements ont été enregistrés pour cet enfant, la suppression de l’arrivée n’est pas autorisée",
  },
  {
    code: 40120,
    fr:
      "Cet enfant est déclaré absent aujourd’hui. Vous devez supprimer l’absence avant de modifier son statut",
    default:
      "Cet enfant est déclaré absent aujourd’hui. Vous devez supprimer l’absence avant de modifier son statut",
  },
  {
    code: 40121,
    fr: "Vous devez indiquer les traitements à administrer",
    default: "Vous devez indiquer les traitements à administrer",
  },
  {
    code: 40122,
    fr: "L’ordonnance pour un des traitements saisi est introuvable",
    default: "L’ordonnance pour un des traitements saisi est introuvable",
  },
  {
    code: 40123,
    fr: "Le traitement est introuvable ou terminé",
    default: "Le traitement est introuvable ou terminé",
  },
  {
    code: 40124,
    fr: "Le traitement est introuvable ou terminé",
    default: "Le traitement est introuvable ou terminé",
  },
  {
    code: 4013,
    fr:
      "La saisie du petit coin ne peut être acceptée que pour la journée courante",
    default:
      "La saisie du petit coin ne peut être acceptée que pour la journée courante",
  },
  {
    code: 4014,
    fr: "La saisie du repas ne peut être acceptée que pour la journée courante",
    default:
      "La saisie du repas ne peut être acceptée que pour la journée courante",
  },
  {
    code: 4015,
    fr: "Vous devez saisir une quantité pour le biberon",
    default: "Vous devez saisir une quantité pour le biberon",
  },
  {
    code: 4016,
    fr:
      "La saisie de la sortie ne peut être acceptée que pour la journée courante",
    default:
      "La saisie de la sortie ne peut être acceptée que pour la journée courante",
  },
  {
    code: 4017,
    fr:
      "La saisie de l’arrivée ne peut être acceptée que pour la journée courante",
    default:
      "La saisie de l’arrivée ne peut être acceptée que pour la journée courante",
  },
  {
    code: 4019,
    fr: "La date de fin de l’absence est antérieure à la date de début",
    default: "La date de fin de l’absence est antérieure à la date de début",
  },
  {
    code: 4020,
    fr: "Une erreur est survenue lors de la suppression de l’absence",
    default: "Une erreur est survenue lors de la suppression de l’absence",
  },
  {
    code: 4021,
    fr: "Un des parents saisis n’est pas associé à l’enfant",
    default: "Un des parents saisis n’est pas associé à l’enfant",
  },
  {
    code: 4022,
    fr:
      "Le parent a activé son compte kiuono, vous n’êtes plus autorisé à modifier ses informations personnelles",
    default:
      "Le parent a activé son compte kiuono, vous n’êtes plus autorisé à modifier ses informations personnelles",
  },
  {
    code: 4023,
    fr:
      "Une erreur est survenue lors de la modification des informations des parents",
    default:
      "Une erreur est survenue lors de la modification des informations des parents",
  },
  {
    code: 4024,
    fr: "Ce parent n’est pas identifié comme parent de l’enfant",
    default: "Ce parent n’est pas identifié comme parent de l’enfant",
  },
  {
    code: 4025,
    fr: "Une erreur est survenue lors du couplage/découplage du compte parent",
    default:
      "Une erreur est survenue lors du couplage/découplage du compte parent",
  },
  {
    code: 4026,
    fr: "La fiche de cet enfant est déjà archivée",
    default: "La fiche de cet enfant est déjà archivée",
  },
  {
    code: 4027,
    fr: "La fiche de cet enfant n’est pas archivée",
    default: "La fiche de cet enfant n’est pas archivée",
  },
  {
    code: 4029,
    fr: "Un des aliments interdits n’est pas reconnu",
    default: "Un des aliments interdits n’est pas reconnu",
  },
  {
    code: 4030,
    fr: "Un des aliments introduits n’est pas reconnu",
    default: "Un des aliments introduits n’est pas reconnu",
  },
  {
    code: 4031,
    fr: "L’un des aliments introduits est reconnu comme aliment interdit",
    default: "L’un des aliments introduits est reconnu comme aliment interdit",
  },
  {
    code: 4032,
    fr: "L’un des aliments interdits est reconnu comme aliment déjà introduit",
    default:
      "L’un des aliments interdits est reconnu comme aliment déjà introduit",
  },
  {
    code: 4034,
    fr: "La date de fin est antérieure à la date de début",
    default: "La date de fin est antérieure à la date de début",
  },
  {
    code: 4035,
    fr: "La période à exporter ne peut pas être supérieures à trois mois",
    default: "La période à exporter ne peut pas être supérieures à trois mois",
  },
  {
    code: 5000,
    fr: "Cette adresse email est déjà utilisés par un autre utilisateur",
    default: "Cette adresse email est déjà utilisés par un autre utilisateur",
  },
  {
    code: 5001,
    fr: "Cet identifiant est déjà utilisé par un autre utilisateur",
    default: "Cet identifiant est déjà utilisé par un autre utilisateur",
  },
  {
    code: 5002,
    fr:
      "Le format du mot de passe est invalide (Au moins 8 caractères dont au moins un chiffre et une lettre majuscule)",
    default:
      "Le format du mot de passe est invalide (Au moins 8 caractères dont au moins un chiffre et une lettre majuscule)",
  },
  {
    code: 5003,
    fr: "Les deux champs mot de passe doivent être identiques",
    default: "Les deux champs mot de passe doivent être identiques",
  },
  {
    code: 5004,
    fr: "L’adresse email est invalide",
    default: "L’adresse email est invalide",
  },
  {
    code: 5005,
    fr: "Le numéro de téléphone est invalide",
    default: "Le numéro de téléphone est invalide",
  },
  {
    code: 5006,
    fr: "Vous avez déjà aimé cette publication",
    default: "Vous avez déjà aimé cette publication",
  },
  {
    code: 5007,
    fr: "Vous n’avez pas aimé cette publication",
    default: "Vous n’avez pas aimé cette publication",
  },
  {
    code: 5008,
    fr:
      "Vous ne pouvez déclarer un retard que si l’enfant est attendu ou déjà présent à la crèche",
    default:
      "Vous ne pouvez déclarer un retard que si l’enfant est attendu ou déjà présent à la crèche",
  },
  {
    code: 6001,
  },
];

const defaultError = "Une erreur est survenue";

export function getError(code) {
  let error = errorList.find((element) => element.code === code);
  if (error) {
    console.log(error);
    return error.fr;
  } else {
    return defaultError;
  }
}
